import AddIcon from "@mui/icons-material/Add"
import CheckIcon from "@mui/icons-material/Check"
import { Chip } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import React from "react"

interface FilterChipProps {
  label: string
  isChecked: boolean
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
}

const useStyles = makeStyles()(
  (theme) => ({
    chip: {
      ...theme.fonts.raleway600,
      height: 41,
      borderRadius: 30,
      padding: "10px 10px 10px 8px",
      fontSize: 18,
      backgroundColor: "#767676",
      color: "#ffffff",
      border: "1.5px solid inherit",
      transition: "scale 0.5s ease-in-out",
      cursor: "pointer",
      "&:focus, &:hover": {
        outlineOffset: 2,
        outline: "1px solid #4D90FE",
      },
      "&:active": {
        transform: "scale(0.98)",
      },

      "&.MuiChip-clickable:hover, &.MuiChip-clickable:focus": {
        backgroundColor: "#767676",
      },

      "&.MuiChip-outlined": {
        color: "#767676",
        backgroundColor: "#ffffff",
        border: "1.5px solid inherit",
        "&:focus, &:hover": {},
        "&.MuiChip-clickable:hover, &.MuiChip-clickable:focus": {
          backgroundColor: "#ffffff",
        },
      },

      "& > .MuiChip-deleteIcon": {
        height: 24,
        width: 24,
        color: "inherit",
        "&:hover": {
          color: "inherit",
        },
      },
    },
  })
)

const FilterChip = (props: FilterChipProps) => {
  const { label, onClick, isChecked } = props
  const { classes } = useStyles()

  return (
    <Chip
      className={classes.chip}
      variant={isChecked ? "filled" : "outlined"}
      label={label}
      onClick={onClick}
      onDelete={onClick}
      deleteIcon={isChecked ? <CheckIcon /> : <AddIcon />}
    />
  )
}

export default FilterChip
